import React from 'react';
import Page from 'common/components/layout/Page';
import AppThemeProvider from 'common/components/theme/AppThemeProvider';

export default (props) => (
    <AppThemeProvider>
        <Page>{props.children}</Page>
    </AppThemeProvider>
);
